const getHtml = () => {
  return `
    <button type="button" class="btn btn-dark">Default</button>
  `;
};

const getCss = () => {
  return ``;
};

const getJs = () => {
  return ``;
};

const DefaultButton = { getHtml, getCss, getJs };

export default DefaultButton;
